import firebase from "firebase";

import { readMacro } from "./Macros/Macros";
import db from "../../firebase/firebase";

export function sendMessage(macroInput, character, channelId, isMacro = false) {
  let message_payload = macroInput;
  let diceRoll = false;
  let diceRollValue = null;
  let dice = null;
  let diceType = null;
  let crit = false;
  let crit_fail = false;
  let modifier = null;
  let numberOfDice = null;
  let emote = null;
  let test = JSON.parse(macroInput).blocks[0].text;

  let macro = readMacro(test);

  if (macro.message === "Success") {
    diceRoll = true;
    diceRollValue = macro.diceRoll;
    dice = macro.dice;
    diceType = macro.diceType;
    modifier = macro.modifier;
    numberOfDice = macro.multiplier;
    message_payload = test;

    // Check for criticial hit
    if (
      diceRoll &
      (macro.dice.reduce((a, b) => a + b, 0) ===
        diceType.reduce((a, b) => a + b, 0))
    ) {
      crit = true;
      emote = character.character.character.critEmote;
    }
    // Check for critical fail
    else if (
      diceRoll &
      (macro.dice.reduce((a, b) => a + b, 0) === macro.dice.length)
    ) {
      crit_fail = true;
      emote = character.character.character.critFailEmote;
    }
  } 
  db.collection("channels")
    .doc(channelId)
    .collection("messages")
    .add({
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      message: message_payload,
      character: character.character.character,
      channelId: channelId,
      meta: {
        emote: emote,
        crit: crit,
        crit_fail: crit_fail,
        diceRoll: diceRoll,
        diceRollValue: diceRollValue,
        diceType: diceType,
        dice: dice,
        modifier: modifier,
        numberOfDice: numberOfDice,
      },
    });
}
